import { render, staticRenderFns } from "./EpcDescription.vue?vue&type=template&id=101a29a2&"
import script from "./EpcDescription.vue?vue&type=script&lang=ts&"
export * from "./EpcDescription.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports